"use strict";
window._theme = window._theme || {};

_theme.handleBundleATC = function() { 

    $(document).on('click','button.cm-add-bndle',function(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        _theme.focusTrap($('#dropdown-cart'),function() {
            _theme.toggleSideCart(false, null, false);
        });
        _theme.toggleLoading(1);

        let vid = $(this).parent().find('.cmVariant').data('id');
        let varID = $(this).parent().find('.offer-quickview-mob-button').data('vid');
        if(vid == undefined || vid == '' || varID != '') {
            vid = varID;
        }
        if(!vid) return;

        // Do Not Remove Code - Add Properties for GWP Discount
        let properties = {};
        let bundleVarIdElement = $(this).closest(".grid-item").find("[data-bundleVarId]");
        if (bundleVarIdElement.length > 0) {
            properties["_bundleVarId"] = bundleVarIdElement.val() || null;
        }
        // Do Not Remove Code - Add Properties for GWP Discount

        _theme.Helpers.addProductToCart(vid, 1, properties, (resp) => {
            _theme.MiniCart.lineItemChangeCallBack(resp, function(){
                _theme.toggleLoading();
                _theme.toggleSideCart(1, null, true);
            });
        }, (err) => {
            console.error(err);
        }, 1);
        
    });
}

$(document).ready(function() {
    $('body,html').animate({
        scrollTop:0
    },0);
    _theme.handleBundleATC();
});